module.exports = __webpack_public_path__ + "media/images/Elliasen Logo PNG-ea77d400.webp";